import { useEffect } from 'react';
import { useParams, Navigate, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { supportedLngs, defaultLng, type Locale } from '@/lib/i18n/config';

export function LocaleLayout() {
  const { locale } = useParams<{ locale: string }>();
  const { i18n } = useTranslation();

  // Vérifier que la locale est supportée
  if (!locale || !supportedLngs.includes(locale as Locale)) {
    return <Navigate to={`/${defaultLng}`} replace />;
  }

  // Changer la langue i18next si nécessaire
  useEffect(() => {
    if (i18n.language !== locale) {
      i18n.changeLanguage(locale);
    }
  }, [locale, i18n]);

  // Mettre à jour l'attribut lang du HTML
  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  return <Outlet />;
}
